import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Input = ({ title, onChange, errorText, style, ...props }) => {
  const handleChange = ({ target: { value } }) => {
    onChange(value);
  };

  const inputStyle = { ...style };

  if (errorText) {
    inputStyle.border = '1px solid red';
  }

  return (
    <div className="input-form">
      {title && <label className="input-label">{title}</label>}
      <input {...props} className="input" onChange={handleChange} style={inputStyle} />
    </div>
  );
};

Input.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  errorText: PropTypes.string,
  style: PropTypes.object,
};

Input.defaultProps = {
  title: '',
  errorText: '',
  style: {},
  onChange: () => {},
};

export { Input };
